import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Paper from "@mui/material/Paper";

import SearchField from "../../Components/SearchField";
import QuestionTypeItem from "./QuestionTypeItem";
import { allQuestions, basicQuestions } from "../itemTypesAddButton";
import { useTranslation } from "react-i18next";
import useClasses from "../../useClasses";
import { getType, isConditionalQuestion } from "../itemTypes";

const styles = (theme) => ({
  search: {
    padding: theme.spacing(1, 1, 1, 1),
    borderBottom: "1px solid rgba(0,0,0,0.2)",
    display: "flex",
  },
  list: {
    maxHeight: "230px",
    minWidth: "252px",
    overflow: "auto",
    transition: theme.transitions.create("max-height", {
      duration: theme.transitions.duration.shortest,
    }),
  },
});

export default function QuestionTypeMenu({
  buttonId,
  handleClose = () => {},
  handleItemClick,
  question,
  showAll,
  handleShowAll,
}) {
  const classes = useClasses(styles);

  const { t } = useTranslation();

  const [userText, setUserText] = useState("");
  const [list, setList] = useState(allQuestions);

  useEffect(() => {
    let newList = [];
    if (showAll && userText === "") {
      newList = [...allQuestions];
    }
    if (!showAll && userText === "") {
      newList = [...basicQuestions];
    }
    if (userText !== "") {
      newList = allQuestions.filter(
        (item) =>
          t(`editor.questionTypes.${item.type}.title`)
            .toLowerCase()
            .indexOf(userText.toLowerCase().replace(/\s/g, "")) !== -1
      );
    }
    if (
      buttonId !== "conditional" &&
      question?.type &&
      isConditionalQuestion(question.type)
    ) {
      // show conditional button
    } else {
      // hide conditional button
      newList = [...newList].filter((item) => item.type !== "conditional");
    }
    setList(newList);
  }, [userText, showAll, question]);

  const onClose = () => {
    setUserText("");
    handleClose();
  };

  return (
    <Paper elevation={4}>
      <ClickAwayListener onClickAway={onClose}>
        <div>
          <div className={classes.search}>
            <SearchField
              setUserText={setUserText}
              placeholder={t("common.search")}
              variant="searchQuestionType"
              autoFocus={true}
            />
          </div>
          <MenuList className={classes.list}>
            {list.length > 0 ? (
              list.map((item) => (
                <QuestionTypeItem
                  id={`buttonType${item.type}`}
                  key={item.type}
                  type={item.type}
                  handleItemClick={handleItemClick}
                  isSelected={false}
                  icon={item.icon}
                  title={t(`editor.questionTypes.${item.type}.title`)}
                  manualUrl={item.manualUrl}
                />
              ))
            ) : (
              <MenuItem disabled>
                <Typography>{t("common.noResults")}</Typography>
              </MenuItem>
            )}
            <MenuItem
              style={{
                display: userText === "" ? "flex" : "none",
                justifyContent: "center",
              }}
              onClick={handleShowAll}
            >
              <Typography variant="body2">
                {showAll ? t("common.buttons.less") : t("common.buttons.more")}
              </Typography>
            </MenuItem>
          </MenuList>
        </div>
      </ClickAwayListener>
    </Paper>
  );
}
